export const colors = {
    primary: "#202020",
    secondary: "#f0ae51",
    dark: "#000",
    gray: "#808080",
    orange: "#ffa500",
    delete: "#DA1E28", // error borders, error text
    border: "#dadce0", //passcode bg
    button: "#2F4D8B", // button bg, passcode border
    title: "#414141",
    box: "#F8FCFF",
    light: "#fff", // container bg, light text
    selection: "#366BBF",
    dot: "#6FDC8C",
    shadow: "#171717",
    selected: "#E0EBFF",
    transparent: "transparent",
    error: "#E44B48",
    disabledText: "rgba(0, 0, 0, 0.26)",
    disabledBg: "#ddd",
    disclaimer: "#6a6a6a",
    scheduled: "green",
    decline: "red",
    errorBox: "#FBEAEA",
    warningBox: "rgb(255, 243, 195)",
    green: "#2F6113",
    greenLight: "#A6DF6F",
    yellow: "#FFCC00",
    yellowLight: "#FFFF66",
    red: "#FF0E0E",
    redLight: "#FFCCCB",
    dialogBackground: "rgba(0,0,0,0.3)",
    grey: "#EDEDED",
    greyLight: "#F9F9F9",
    path: "#E8ECEF",
    stepperBackground: "#2F4D8B",
    infoBoxBackground: "#FDF0E6",
    errorText: "#5F2B01",
    warningColor: "#ED6C02",
    adminInfoIconColor: "#0288D1",
    adminInfoTextColor: "#013654",
    adminInfoBackgroundColor: "#E6F3FA",
    errorBorder: "#E44B48",
    adminPlaceholderBackground: "#FAFAFA",
    adminPlaceholderBorder: "rgba(0,0,0,0.12)",
    infoBox: "#E6F3FA",
    infoIcon: "#0288D1",
    noticeIcon: "#ED6C02",
    noticeText: "#5F2B01",
    noticeBox: "#FDF0E6",
    infoText: "#013654",
    shiftCalendarButtonBorder: "#79747E",
    shiftCalendarText: "#49454F",
    seniorityBadgeBackground: "#F2F5F7",
    // Role-named additions for the Revenue Forecasting board refactor. Named by
    // what they do, never by hue, so other features can adopt them.
    pageBackground: "#F5F5F5", // app page ground behind PageLayout cards
    buttonHover: "#25406F", // darkened `button` for hover on a filled primary
    successBox: "#EAF1EC", // pairs with `green` the way errorBox pairs with error
    onPrimaryMuted: "rgba(255,255,255,0.7)", // secondary text on a filled primary
    // The "you are here" band behind a board's current-week column. A cool
    // neutral rather than a tint of `button`, so the chips sitting on it keep
    // their own blue (`selected`), amber (`noticeBox`) and red (`errorBox`)
    // fills — a blue band under a blue chip reads as one flat block.
    currentColumnBand: "#EDF1F5",
    // The error role at *text* weight. `error` (#E44B48) is a fill, a border and
    // a bar: it clears the 3:1 floor for a graphic and nothing more, so as small
    // text on white it measures 3.89 and as a fill behind white text 3.89 again
    // — both under AA. This is the same role darkened until it passes on every
    // ground the app puts it on (>=4.8 on white, greyLight, box and errorBox,
    // 6.5 for white on it). Use it wherever error red carries or backs words;
    // keep `error` for bars, swatches, borders and markers.
    errorStrong: "#B3261E",
    // design/kpi-card's icon tones. These are the pairs evaluations, the
    // attendance reports and worker activity already draw the card with,
    // named here so a fourth feature does not have to copy the hexes out of
    // a third — and so a KPI card stops being the one place on a page where
    // the app's success green is `green` rather than this one.
    kpiNeutralBox: "#CEE1FF",
    kpiNeutralIcon: "#1565C0",
    kpiPositiveBox: "#E8F5E9",
    kpiPositiveIcon: "#2E7D32",
    kpiNegativeBox: "#FEEBEE",
    kpiNegativeIcon: "#C62828",
};
export default colors;
